import { Routes, Route, useLocation } from "react-router-dom";

// Admin Pages
import Dashboard from './component/dashboard';
import Profile from './component/profile';
import PasswordChange from './component/passwordChange';
import Agent from './component/agent';
import Verfywallethistoryall from './component/verfywallethistoryall';
import Wallethistory from './component/wallethistory';
import Pendingpayment from './component/pendingpayment';
import Customers from './component/customers';
import Addagent from './component/Addagent';
import AdminLayout from './layouts/AdminLayout';

// Agent Pages (some shared)
import AgentLayout from './layouts/AgentLayout';

// Auth Pages
import Joinnow from './component/joinnow';
import Deposit from './component/Deposit';
import Login from "./component/Login/Login";

function App() {
  const location = useLocation();

  const isJoinNowPage = location.pathname === '/joinnow' || location.pathname === '/Deposit';

  return (
    <>
      {isJoinNowPage ? (
        <Routes>
          <Route path='/joinnow' element={<Joinnow />} />
          <Route path='/Deposit' element={<Deposit />} />
        </Routes>
      ) : (
        <Routes>
          {/* Admin Panel Routes */}
          <Route path='/admin' element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path='profile' element={<Profile />} />
            <Route path='passwordchange' element={<PasswordChange />} />
            <Route path='agent' element={<Agent />} />
            <Route path='addagent' element={<Addagent />} />
            <Route path='pending-payment' element={<Pendingpayment />} />
            <Route path='wallethistory' element={<Wallethistory />} />
            <Route path='verfywallethistoryall' element={<Verfywallethistoryall />} />
            <Route path='customers' element={<Customers />} />
          </Route>

          {/* Agent Panel Routes */}
          <Route path='/agent' element={<AgentLayout />}>
            <Route index element={<Dashboard />} />
            <Route path='profile' element={<Profile />} />
            <Route path='passwordchange' element={<PasswordChange />} />
            <Route path='wallethistory' element={<Wallethistory />} />
            <Route path='verfywallethistoryall' element={<Verfywallethistoryall />} />
            <Route path='customers' element={<Customers />} />
          </Route>

          <Route path= '/' element={<Login />}> </Route>
        </Routes>
       
      )}
    </>
  );
} export default App;
